import React, { memo, lazy } from 'react';
import { Switch, Route } from 'react-router';

const ComponentsCost = lazy(() => import('../views/ComponentsCost'));
const ProductionCost = lazy(() => import('../views/ProductionCost'));

const CostRouts = ({ url }) => (
  <Switch>
    <Route
      exact
      path={`${url}/:projectId/:modelId/components-cost`}
      render={({ history, match }) => <ComponentsCost history={history} match={match} />}
    />
    <Route
      exact
      path={`${url}/:projectId/:modelId/production-cost`}
      render={() => <ProductionCost />}
    />
  </Switch>
);

export default memo(CostRouts);
